import { toast } from "@grandvisionhq/common";
const triggerToastMessage = (type) => {
  switch (type) {
    case "generic-non-recoverable-error":
      toast.failed("common.errors.nonrecoverable.generic");
      break;
    case "non-recoverable-rx-error":
      toast.failed("products.contactLenses.prescription.queryError.nonRecoverable");
      break;
    case "recoverable-error":
      toast.failed("products.contactLenses.prescription.queryError.recoverable");
      break;
    case "delivery-interval-error":
      toast.failed("products.deliveryInterval.error");
      break;
    case "prescription-form-error":
      toast.failed("products.contactLenses.prescription.error");
      break;
    case "quantity-invalidated-warning":
      toast.warning("products.contactLenses.selectedQuantity.invalidated");
      break;
  }
};
export {
  triggerToastMessage
};
//# sourceMappingURL=trigger-toast-message.js.map
